<script>
  import { User } from "sveltefire";
  import { push } from "svelte-spa-router";

  import Form from "../smart/Form.svelte";
  import EmailInput from "../dumb/EmailInput.svelte";
  import PasswordInput from "../dumb/PasswordInput.svelte";
  import Button from "../dumb/Button.svelte";

  //export let provider;
  let errorMessage = "";

  const emailSignUp = (auth) => {
    console.log("Sign Up Button Pressed");
    auth
      .createUserWithEmailAndPassword(email, password)
      .then((user) => {
        error = "Successfully Created Account"
        // Signed in
        // ...
      })
      .catch((error) => {
        errorMessage = `[${error.code}] ${error.message}`;
        email = "";
        password = "";
        // ..
      });
  };

  let email;
  let password;
</script>

<div class="login">
  <User let:auth let:user>
    <div slot="default" class="login__container">
      <p>Signed in as {user.uid}</p>

      <button on:click={() => push('/organize')}>Organize</button>
      <button on:click={() => auth.signOut()}>Sign Out</button>
    </div>
    <div slot="signed-out" class="login__container">
      <Form>
        <img src="images/scriber-logo.svg" alt="Scriber Logo" />
        <h2>Sign Up</h2>

        <EmailInput bind:email />
        <PasswordInput bind:password />

        <Button text="Create Account" on:click={ () => emailSignUp(auth)}/>
        <p class="message">Already have an account? <a href="/">Sign In</a></p>
        <p class="error">{errorMessage}</p>
      </Form>
    </div>
  </User>
</div>
 
<style>

  .error {
    color: red;
  }

  .login {
    background: var(--dark-brown);
    font-family: "Roboto", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100vh;
  }

  .login__container {
    width: 360px;
    padding: 8% 0 0;
    margin: auto;
  }
</style>
